import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { darkShadows, shadows } from "Infrastructure/Theme/shadows";
import { createTheme } from "@mui/material/styles";
import { useAtom } from "jotai";
import { components } from "./components";
import { palettes } from "./palettes";
import { typography } from "./typography";

/*
 * TypeScript module augmentation for MUI components.
 */
declare module "@mui/material/Chip" {
	interface ChipPropsColorOverrides {
		progress: true;
	}
}

declare module "@mui/material/styles" {
	interface TypographyVariants {
		tableCell: React.CSSProperties;
	}

	// allow configuration using `createTheme`
	interface TypographyVariantsOptions {
		tableCell?: React.CSSProperties;
	}

	interface Palette {
		progress: Palette["primary"];
	}
	interface PaletteOptions {
		progress?: PaletteOptions["primary"];
	}
}

declare module "@mui/material/Typography" {
	interface TypographyPropsVariantOverrides {
		tableCell: true;
	}
}

export function setupTheme() {
	const [themeConfig] = useAtom(themeAtom);
	const mode = themeConfig.activeMode === "dark" ? "dark" : "light";

	const palette = palettes[mode] || palettes.default;
	const themeShadows = mode === "dark" ? darkShadows : shadows;

	let theme = createTheme({
		palette: {
			...palette,
			mode,
		},
		shape: {
			borderRadius: themeConfig.borderRadius,
		},
		typography,
		shadows: themeShadows,
		direction: themeConfig.activeDir,
	});

	theme = createTheme(theme, {
		components: components(theme),
	});

	return theme;
}
